import React, { useState, useEffect } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment/moment";
import { useSelector } from "react-redux";
import "../../pagination/pagination.css";
import Pagination from "../../pagination/pagination";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../../services/apiService";
import { getName, getUserName } from "../../../../Redux/selecters";
import { toast } from "react-toastify";
import { ClipLoader } from "react-spinners";
import Modal from 'react-bootstrap/Modal';
import { useCurrency } from '../../../../INVENTORY/Layouts/currencyContext';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const REPORT_URL = process.env.REACT_APP_REPORTS_URL
const RenewListing = () => {
  const [rowData, setRowData] = useState([]);
  const [proprtyList, setProperty] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [loader, setloader] = useState(true);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(20);
  const [pagination, setPagination] = useState();
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedtem, setSelectedItem] = useState(null);
  const [renewBulkModal, setRenewBulkModal] = useState(false);
  const [renewBulkSaving, setRenewBulkSaving] = useState(false);
  const [renewBulkDate, setRenewBulkDate] = useState(new Date());
  const [renewSkipOnOverlap, setRenewSkipOnOverlap] = useState(true);
  const [terminationBulkModal, setTerminationBulkModal] = useState(false);
  const [terminationBulkSaving, setTerminationBulkSaving] = useState(false);
  const [terminationTranDate, setTerminationTranDate] = useState(new Date());
  const [terminationNoticeDate, setTerminationNoticeDate] = useState(new Date());
  const [terminationKeyReturnDate, setTerminationKeyReturnDate] = useState(new Date());
  const [terminationVacatingDate, setTerminationVacatingDate] = useState(new Date());
  const [terminationReason, setTerminationReason] = useState("");
  const [terminationRemarks, setTerminationRemarks] = useState("");
  const [terminationUseComputedBalance, setTerminationUseComputedBalance] = useState(true);
  const apiService = new LeaseApiService();
  const userName = useSelector(getName);
  const [FilterTab, setFilterTab] = useState(true);
  const [permissions, setPermissions] = useState([]);
  const [additionalChargesModal, setAdditionalChargesModal] = useState(false);
  const [additionalCharges, setAdditionalCharges] = useState([]);
  const [taxCodeList, setTaxCodeList] = useState([]);
  const [chargesLoading, setChargesLoading] = useState(false);
  const [chargesSaving, setChargesSaving] = useState(false);
  const [activeLeaseRow, setActiveLeaseRow] = useState(null);
  const [activeLeaseUnitDetails, setActiveLeaseUnitDetails] = useState(null);
  const [contextMenu, setContextMenu] = useState(null);
  const { currencyPrecision } = useCurrency();
  let navigate = useNavigate();
  const location = useLocation();
  const StatusFilter = [
    { value: "0", label: "Active" },
  ]
  const [formData, setFormData] = useState({
    email: "",
    Proprty: [{ label: "Select Property", value: "" }],
    Status: [{ label: "Active", value: "" }],
    Unit: [{ label: "Select Unit", value: "" }],
    LeaseNo: [{ label: "Select Lease No", value: "" }],
    from: "",
    to: "",
  })
  const formatDate = (date) => {
    return moment(date).format("DD-MMM-YYYY");
  }
  useEffect(() => {
    const storedPermissions =
      JSON.parse(localStorage.getItem("RoleAccess")) || [];
    const permissions = storedPermissions?.filter(
      (acc) => acc.formName === "Purchase Requisition"
    );
    setPermissions(permissions[0]);
  }, [])
  useEffect(() => {
    fetchDropdownData();

    const today = new Date();

    const fromDate = new Date(today);
    fromDate.setMonth(today.getMonth() - 1);
    fromDate.setDate(fromDate.getDate() - 1);

    const formattedFrom = formatDate(fromDate);
    const formattedTo = formatDate(today);

    setFormData((prev) => ({
      ...prev,
      from: formatDate(fromDate),
      to: formatDate(today),
    }));

    getItems(1, { from: formattedFrom, to: formattedTo });
  }, []);

  useEffect(() => {
    const handleClickOutside = () => setContextMenu(null);
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [])
  const fetchDropdownData = async () => {
    try {
      const params = new URLSearchParams();
      params.append("dropdownTypes", "LASerPropertyName");
      const res = await apiService.getApiParamater(
        "GET_PROPERT_DROP",
        `?${params.toString()}`
      );
      setProperty(res?.data?.dropdowns?.LASerPropertyName);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  }
  const loadAdditionalCharges = async (leaseRow) => {
    if (!leaseRow?.groupId) return;
    try {
      setChargesLoading(true);
      setActiveLeaseRow(leaseRow);
      const dropdownParams = new URLSearchParams();
      dropdownParams.append("dropdownTypes", "VatPercentage");
      const dropdownRes = await apiService.getApiParamater(
        "GET_PROPERT_DROP",
        `?${dropdownParams.toString()}`
      );
      setTaxCodeList(dropdownRes?.data?.dropdowns?.VatPercentage || []);

      const leaseDataParam = new URLSearchParams();
      leaseDataParam.append("Action", "getLeaseDetailsById");
      leaseDataParam.append("GroupId", leaseRow?.groupId);
      const leaseDataRes = await apiService.getApiParamater(
        "GET_UNITNO_DATA",
        `?${leaseDataParam.toString()}`
      );
      const leaseResData =
        leaseDataRes?.data?.result?.data?.length > 0
          ? leaseDataRes.data.result.data[0]
          : leaseDataRes?.data?.result?.data;
      setActiveLeaseUnitDetails(leaseResData);

      const additionalParam = new URLSearchParams();
      additionalParam.append("Action", "GetChargesDetails");
      additionalParam.append("RentPerAnnum", leaseResData?.Rent_Per_Annum);
      const Additionalres = await apiService.getApiParamater(
        "GET_UNITNO_DATA",
        `?${additionalParam.toString()}`
      );

      const isSecurityDeposit = (item) => /security deposit/i.test(item?.Description || "");

      const additional = Additionalres?.data?.result?.data;
      let updatedData = [];
      if (additional?.length > 0) {
        updatedData = additional.map((item) => ({ ...item, isSelected: !isSecurityDeposit(item), isRenewalLocked: false }));
      } else if (additional?.Description) {
        updatedData = [{ ...additional, isSelected: !isSecurityDeposit(additional), isRenewalLocked: false }];
      }
      setAdditionalCharges(updatedData);
    } catch (error) {
      console.error("Error fetching additional charges:", error);
      setAdditionalCharges([]);
    } finally {
      setChargesLoading(false);
    }
  }
  const preventNegativeSign = (e) => {
    if (e.key === "-" || e.key === "+") {
      e.preventDefault();
    }
  }
  const resolveTaxCodeValue = (row) => {
    if (row?.TaxCodeValue !== undefined && row?.TaxCodeValue !== null && row?.TaxCodeValue !== "") {
      return row.TaxCodeValue;
    }
    const byId = taxCodeList.find(
      (tc) => String(tc.value) === String(row?.TaxCode ?? row?.TaxCodeId ?? row?.VATPercent ?? "")
    );
    if (byId) return byId.value;
    const rowText = (row?.VATDescription || "").trim().toLowerCase();
    const byText = taxCodeList.find((tc) => (tc.text || "").trim().toLowerCase() === rowText);
    return byText?.value || "";
  }
  const handleVatChange = async (index, selectedValue) => {
    const selectedOption = taxCodeList.find((tc) => String(tc.value) === String(selectedValue));
    if (!selectedOption) return;

    const taxParam = new URLSearchParams();
    taxParam.append("Action", "GetTaxRecordIdByTaxName");
    taxParam.append("TaxDescription", selectedOption.text);

    try {
      const taxrecord = await apiService.getApiParamater("GET_UNITNO_DATA", `?${taxParam.toString()}`);
      const result = taxrecord?.data?.result?.data;

      if (result) {
        setAdditionalCharges((prev) => {
          const updated = [...prev];
          const row = { ...updated[index] };

          row.TaxCodeValue = selectedValue;
          row.VATDescription = selectedOption.text;
          row.VATRate = result.Rate;

          const vat = (parseFloat(row.Amount || 0) * result.Rate) / 100;
          row.VAT = vat || 0;
          row.Total = parseFloat(row.Amount || 0) + vat;

          updated[index] = row;
          return updated;
        });
      }
    } catch (error) {
      console.error("Failed to fetch VAT data:", error);
    }
  }
  const handleCheckboxChange = async (index, field, value) => {
    const updated = [...additionalCharges];
    updated[index][field] = value;
    const addData = updated[index];
    if (field === "isSelected") {
      updated[index].isSelected = value;
    }
    if (field === "Rate" || field === "Qty") {
      const rate = field === "Rate" ? parseFloat(value) || 0 : parseFloat(addData?.Rate) || 0;
      const qty = field === "Qty" ? parseFloat(value) || 0 : parseFloat(addData?.Qty) || 0;
      const vatdes = addData?.VATDescription;
      const amount = rate * qty;
      if (vatdes) {
        const taxParam = new URLSearchParams();
        taxParam.append("Action", "GetTaxRecordIdByTaxName");
        taxParam.append("TaxDescription", vatdes);
        const taxrecord = await apiService.getApiParamater("GET_UNITNO_DATA", `?${taxParam.toString()}`);
        const result = taxrecord?.data?.result?.data;
        const VATRate = result?.Rate || 0;
        const vat = (parseFloat(amount || 0) * VATRate) / 100;
        updated[index][field] = value;
        updated[index].VATRate = VATRate;
        updated[index].VAT = vat || 0;
        updated[index].Amount = amount;
        updated[index].Total = parseFloat(amount || 0) + vat;
      } else {
        updated[index][field] = value;
        updated[index].Amount = amount;
        updated[index].Total = amount;
      }
    }
    setAdditionalCharges(updated);
  }
  const closeAdditionalChargesModal = () => {
    setAdditionalChargesModal(false);
    setAdditionalCharges([]);
    setActiveLeaseRow(null);
    setActiveLeaseUnitDetails(null);
  }
  const handleSaveAdditionalCharges = async () => {
    const selectedCharges = additionalCharges?.filter((row) => row.isSelected);
    if (!selectedCharges || selectedCharges.length === 0) {
      toast.warning("Please select at least one charge to save");
      return;
    }
    try {
      setChargesSaving(true);
      const currentDatetimeUTC = new Date().toISOString();
      const propertyNo = activeLeaseUnitDetails?.Property_Id || "";
      const propertyName = activeLeaseRow?.propertyName || activeLeaseUnitDetails?.Property_Name || "";
      const lines = selectedCharges.map((row) => ({
        recordId: 0,
        groupId: activeLeaseRow?.groupId || 0,
        leaseNo: activeLeaseRow?.leaseNo || "",
        propertyNo,
        propertyName,
        unitNo: activeLeaseRow?.unitNo || activeLeaseUnitDetails?.Unit_No || "",
        unitRefNo: activeLeaseUnitDetails?.UnitRefNo || "",
        tenantNo: activeLeaseRow?.tenantNo || "",
        tenantName: activeLeaseRow?.tenantName || "",
        category: activeLeaseUnitDetails?.Unit_Category || "",
        mId: row?.RecordId || 0,
        description: row?.Description || "",
        taxCode: parseInt(resolveTaxCodeValue(row)) || 0,
        taxInclusive: row?.TaxInclusive || false,
        amount: parseFloat(row?.Amount) || 0,
        vat: parseFloat(row?.VAT) || 0,
        total: parseFloat(row?.Total) || 0,
        receiptNo: "0",
        receiptDate: currentDatetimeUTC,
        remarks: row?.Remarks || "",
        posting: row?.Posting || false,
        drAcCode: row?.DrAcCode || activeLeaseRow?.tenantNo || "",
        drAcName: row?.DrAcName || activeLeaseRow?.tenantName || "",
        crAcCode: row?.CrAcCode || row?.AccountCode || "0",
        crAcName: row?.CrAcName || row?.CreditAccount || "0",
        voucherNo: "0",
        voucherDate: currentDatetimeUTC,
        financialYear: "",
        isDeposit: row?.IsDeposit || false,
        status: "0",
        psdId: 0,
        exp1: "0",
        exp2: "0",
        exp3: "0",
        exp4: "0",
        exp5: "0",
        modifiedBy: userName,
        modifiedOn: currentDatetimeUTC,
        createdBy: userName,
        createdOn: currentDatetimeUTC,
      }));
      const body = {
        groupId: activeLeaseRow?.groupId || 0,
        leaseNo: activeLeaseRow?.leaseNo || "",
        propertyNo,
        propertyName,
        lines,
      };
      await apiService.post("SAVE_ADDITION_AMOUNT_RENEW_LINES", body);
      toast.success("Additional charges saved successfully");
      closeAdditionalChargesModal();
    } catch (error) {
      console.error("Error saving additional charges:", error);
      toast.error("Failed to save additional charges");
    } finally {
      setChargesSaving(false);
    }
  }
  const getItems = async (newPageNo = pagination?.currentPage, overrides = {}) => {
    try {
      const params = new URLSearchParams();
      params.append("PageNo", newPageNo || 1);
      params.append("PageSize", pageSize || 20);
      params.append("PropertyName", overrides.propertyName ?? formData?.Proprty?.label ?? "");
      params.append("Status", overrides.status ?? formData?.Status?.label ?? "Active");
      params.append("UnitNo", overrides.unitNo ?? formData?.Unit?.label ?? "");
      params.append("FromDate", overrides.from ?? formData?.from ?? "");
      params.append("ToDate", overrides.to ?? formData?.to ?? "");
      const res = await apiService.getApiParamater(
        "GET_LEASE_AGRE",
        `?${params.toString()}`
      );

      setRowData(res?.data?.result || []);
      setPagination(res.data.paginationData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching items:", error);
      setLoading(false);
    }
  }
  const dateFormatter = (params) => {
    const date = moment(params.value);
    return date.format("DD-MMM-YYYY");
  }
  const dateComparator = (date1, date2) => {
    const momentDate1 = moment(date1);
    const momentDate2 = moment(date2);
    return momentDate1.isSame(momentDate2)
      ? 0
      : momentDate1.isBefore(momentDate2)
        ? -1
        : 1;
  }
  const columnDefs = [
    {
      headerName: "",
      suppressMovable: true,
      sortable: false,
      filter: false,
      width: 50,
      pinned: "left",
      cellRenderer: (params) => (
        <div className="center">
          <span
            onClick={(e) => {
              e.stopPropagation();
              setContextMenu({ mouseX: e.clientX, mouseY: e.clientY, data: params.data });
            }}
            style={{ cursor: "pointer", fontSize: "24px" }}
          >
            &#8942;
          </span>
        </div>
      ),
    },
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      suppressMovable: true,
      width: 50,
      pinned: "left",
    },
    {
      headerName: "Status",
      field: "status",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 120,
      pinned: "left",
    },
    {
      headerName: "Lease No",
      field: "leaseNo",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 120,
      pinned: "left",
    },
    {
      headerName: "Period From",
      field: "leaseStart",
      filter: true,
      floatingfilter: true,
      valueFormatter: dateFormatter,
      comparator: dateComparator,
      suppressMovable: true,
      width: 136,
    },
    {
      headerName: "Period To",
      field: "leaseEnd",
      filter: true,
      floatingfilter: true,
      valueFormatter: dateFormatter,
      comparator: dateComparator,
      suppressMovable: true,
      width: 136,
    },
    {
      headerName: "Property",
      field: "propertyName",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 250,
    },
    {
      headerName: "Unit Num",
      field: "unitNo",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 100,
    },
    {
      headerName: "Unit Type",
      field: "unitType",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 100,
    },
    {
      headerName: "Account Code",
      field: "tenantNo",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 250,
    },
    {
      headerName: "Tenant",
      field: "tenantName",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 250,
    },
    {
      headerName: "Contact Num",
      field: "contactNo",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: "Year Rent",
      field: "yearRent",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: "Discount",
      field: "discount",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: "Contract Value",
      field: "total",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: "Rent",
      field: "rent",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 100,
    },
    {
      headerName: "VAT",
      field: "vat",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: "Total",
      field: "total",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 100,
    },
    {
      headerName: "Tax",
      field: "tax",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: "BedRooms",
      field: "tax1",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: "Area",
      field: "totalArea",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 100,
    },
    {
      headerName: "Installments",
      field: "installments",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: "Invoices Generated",
      field: "invoicesGenerated",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 150,
    },
    {
      headerName: "Invoices Pending",
      field: "invoicesPending",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 150,
    },
    {
      headerName: "Remarks",
      field: "remarks",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 180,
    },
    {
      headerName: "Modified",
      field: "modifiedBy",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: "Modified On",
      field: "modifiedOn",
      filter: true,
      floatingfilter: true,
      valueFormatter: dateFormatter,
      comparator: dateComparator,
      suppressMovable: true,
      width: 136,
    },
    {
      headerName: "Created By",
      field: "createdBy",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: "Created on",
      field: "createdOn",
      filter: true,
      floatingfilter: true,
      valueFormatter: dateFormatter,
      comparator: dateComparator,
      suppressMovable: true,
      width: 136,
    },
  ]
  const onSelectionChanged = async (event) => {
    const rows = event.api.getSelectedRows();
    setSelectedRow(rows.length === 1 ? rows[0] : null);
    setSelectedRows(rows);
  }
  const closeRenewBulkModal = () => {
    setRenewBulkModal(false);
    setRenewBulkDate(new Date());
    setRenewSkipOnOverlap(true);
  }
  const handleRenewBulk = async () => {
    if (!selectedRows || selectedRows.length === 0) {
      toast.warning("Please select at least one lease to renew");
      return;
    }
    try {
      setRenewBulkSaving(true);
      const body = {
        renewalMain: {
          groupIds: selectedRows.map((row) => row?.groupId),
          tranDate: renewBulkDate ? new Date(renewBulkDate).toISOString() : new Date().toISOString(),
          dateRule: 0,
          chargeBase: 0,
          skipOnOverlap: renewSkipOnOverlap,
        },
      };
      const res = await apiService.post("RENEW_LEASE_BULK", body);
      const summary = res?.data?.result;
      if (summary) {
        toast.success(`Renewed ${summary.succeeded}/${summary.requested} lease(s)${summary.skipped ? `, ${summary.skipped} skipped` : ""}${summary.failed ? `, ${summary.failed} failed` : ""}`);
      } else {
        toast.success("Leases renewed successfully");
      }
      closeRenewBulkModal();
      setSelectedRows([]);
      getItems();
    } catch (error) {
      console.error("Error renewing leases:", error);
      toast.error("Failed to renew selected leases");
    } finally {
      setRenewBulkSaving(false);
    }
  }
  const closeTerminationBulkModal = () => {
    setTerminationBulkModal(false);
    setTerminationTranDate(new Date());
    setTerminationNoticeDate(new Date());
    setTerminationKeyReturnDate(new Date());
    setTerminationVacatingDate(new Date());
    setTerminationReason("");
    setTerminationRemarks("");
    setTerminationUseComputedBalance(true);
  }
  const handleTerminateBulk = async () => {
    if (!selectedRows || selectedRows.length === 0) {
      toast.warning("Please select at least one lease to terminate");
      return;
    }
    try {
      setTerminationBulkSaving(true);
      const body = {
        leaseNos: selectedRows.map((row) => row?.leaseNo),
        transactionDate: terminationTranDate ? new Date(terminationTranDate).toISOString() : new Date().toISOString(),
        noticeDate: terminationNoticeDate ? new Date(terminationNoticeDate).toISOString() : new Date().toISOString(),
        keyReturnDate: terminationKeyReturnDate ? new Date(terminationKeyReturnDate).toISOString() : new Date().toISOString(),
        datePaidOnVacating: terminationVacatingDate ? new Date(terminationVacatingDate).toISOString() : new Date().toISOString(),
        reason: terminationReason,
        remarks: terminationRemarks,
        useComputedBalance: terminationUseComputedBalance,
        debugOnly: false,
      };
      const res = await apiService.post("TERMINATE_LEASE_BULK", body);
      if (!res?.data?.isSuccessful) {
        const errorMsg = res?.data?.errors?.length
          ? res.data.errors.join(", ")
          : res?.data?.message || "Failed to terminate selected leases";
        toast.error(errorMsg);
        return;
      }
      const summary = res?.data?.result;
      if (summary) {
        toast.success(`Terminated ${summary.succeeded}/${summary.totalSelected} lease(s)${summary.failed ? `, ${summary.failed} failed` : ""}`);
      } else {
        toast.success("Leases terminated successfully");
      }
      closeTerminationBulkModal();
      setSelectedRows([]);
      getItems();
    } catch (error) {
      console.error("Error terminating leases:", error);
      toast.error("Failed to terminate selected leases");
    } finally {
      setTerminationBulkSaving(false);
    }
  }
  const handleClearFilters = () => {
    const today = new Date();
    // First day of current month
    const fromDate = new Date(today.getFullYear(), today.getMonth(), 1);
    // Last day of current month
    const toDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const formattedFrom = formatDate(fromDate);
    const formattedTo = formatDate(toDate);

    setUnitList([]);
    setFormData({
      Proprty: [{ label: "Select Property", value: "" }],
      Unit: [{ label: "Select Unit", value: "" }],
      LeaseNo: [{ label: "Select Lease No", value: "" }],
      Status: [{ label: "Active", value: "" }],
      from: formattedFrom,
      to: formattedTo,
    });
    getItems(1, { propertyName: "", status: "Active", unitNo: "", from: formattedFrom, to: formattedTo });
  }
  const handlePropertyChange = async (selectedOption) => {
    setFormData((prev) => ({ ...prev, Proprty: selectedOption, Unit: [{ label: "Select Unit", value: "" }] }));
    try {
      const params = new URLSearchParams();
      params.append("DropdownFor", "LRAgreehUnitNosByPropertyId");
      params.append("CascadValue", selectedOption?.value);
      const res = await apiService.getApiParamater(
        "REPORT_CASCAD",
        `?${params.toString()}`
      );
      setUnitList(res?.data?.items || []);
    } catch (error) {
      console.error("Error fetching unit dropdown data:", error);
      setUnitList([]);
    }
  }
  const handleUnitChange = (selectedOption) => {
    setFormData({ ...formData, Unit: selectedOption });
  }
  const handleDateChange = (name, date) => {
    setFormData((prev) => ({ ...prev, [name]: date ? formatDate(date) : "" }));
  }
  const handleStatusFilter = (selectedOption) => {
    if (selectedOption.label == "All") {
      handleClearFilters();
    } else {
      setFormData({ ...formData, Status: selectedOption });
    }
  }
  return (
    <div className="p-3 ">
      <div className="cost-center-section">
        <div
          className="d-flex  cursor-pointer slide-header"
          onClick={() => setFilterTab(!FilterTab)}
        >
          <div className="h6 pt-1">Search Parameters</div>
        </div>
        <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
          <div
            className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"
              }`}
          >
            <div className="row">
              <div className="col-4">
                <Select
                  className="p-0"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                      color: state.isFocused ? "#000 " : "#000",
                      ":hover": {
                        backgroundColor: "#F5F5F5",
                        color: "#000 ",
                      },
                    }),
                  }}
                  value={formData.Proprty}
                  onChange={(selectedOption) =>
                    handlePropertyChange(selectedOption)
                  }
                  options={proprtyList?.map((rec) => ({
                    value: rec?.value,
                    label: rec?.text,
                  }))}
                />
              </div>
              <div className="col-4">
                <Select
                  className="p-0"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                      color: state.isFocused ? "#000 " : "#000",
                      ":hover": {
                        backgroundColor: "#F5F5F5",
                        color: "#000 ",
                      },
                    }),
                  }}
                  value={formData.Status}
                  options={StatusFilter}
                  onChange={handleStatusFilter}
                />
              </div>
              <div className="col-4">
                <Select
                  className="p-0"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  isClearable
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                      color: state.isFocused ? "#000 " : "#000",
                      ":hover": {
                        backgroundColor: "#F5F5F5",
                        color: "#000 ",
                      },
                    }),
                  }}
                  placeholder="Select Unit"
                  value={formData.Unit}
                  onChange={handleUnitChange}
                  options={unitList?.map((rec) => ({
                    value: rec?.value,
                    label: rec?.text,
                  }))}
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-4">
                <DatePicker
                  selected={formData.from}
                  onChange={(date) => handleDateChange("from", date)}
                  dateFormat="dd-MMM-yyyy"
                  placeholderText="From Date"
                  className="p-2 form-control w-100"
                />
              </div>
              <div className="col-4">
                <DatePicker
                  selected={formData.to}
                  onChange={(date) => handleDateChange("to", date)}
                  dateFormat="dd-MMM-yyyy"
                  placeholderText="To Date"
                  className="p-2 form-control w-100"
                />
              </div>
              <div className="col-4 d-flex gap-1">
                <div
                  onClick={() => getItems()}
                  className="mainbtnGry flex-end gap-2 w-50"
                >
                  <FaFileCircleExclamation
                    color="#fff"
                    className="center mt-1 mx-2"
                  />
                  <div className="center">Search</div>
                </div>
                <div
                  onClick={() => handleClearFilters()}
                  className="mainbtnRed flex-end gap-2 w-50"
                >
                  <RiRefreshLine color="#fff" className="center mt-1 mx-2" />
                  <div className="center">Reset</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-box2 p-4">
        {loading ? (
          <div>Loading...</div>
        ) : (
          <>
            <div className="d-flex justify-contant-between ">
              <h5 className="col mainInvHead">Lease Renewal List</h5>
              <div className="d-flex justify-content-end gap-1">
                <div className="col center">
                  <button
                    className="mainbtnRed"
                    type="button"
                    style={{ minWidth: "180px" }}
                    disabled={selectedRows.length === 0}
                    onClick={() => setTerminationBulkModal(true)}
                  >
                    <FaFileCircleExclamation color="#fff" className="center mt-1" />{" "}
                    <div>Termination{selectedRows.length > 0 ? ` (${selectedRows.length})` : ""}</div>
                  </button>
                </div>
                <div className="col center">
                  <button
                    className="mainbtn "
                    type="submit"
                    style={{ minWidth: "180px" }}
                    disabled={selectedRows.length === 0}
                    onClick={() => setRenewBulkModal(true)}
                  >
                    <RiRefreshLine color="#fff" className="center mt-1" />{" "}
                    <div>Renew{selectedRows.length > 0 ? ` (${selectedRows.length})` : ""}</div>
                  </button>
                </div>
              </div>
            </div>
            <div className="gridshad  mt-3">
              <div className="ag-theme-quartz" style={{ height: 650 }}>
                <AgGridReact
                  getRowStyle={(params) => {
                    if (params.node.rowIndex % 2 === 0) {
                      return { background: "#F0EDF5" };
                    } else {
                      return { background: "#fff" };
                    }
                  }}
                  rowData={rowData}
                  enableFilter={true}
                  floatingFilter={true}
                  columnDefs={columnDefs}
                  rowSelection="multiple"
                  suppressRowClickSelection={true}
                  onSelectionChanged={onSelectionChanged}
                />
              </div>
              <Pagination
                pageSize={pageSize}
                setPageSize={setPageSize}
                pagination={pagination}
                getItems={getItems}
              />
            </div>
          </>
        )}
      </div>

      {contextMenu && (
        <div
          style={{
            position: "absolute",
            top: contextMenu.mouseY,
            left: contextMenu.mouseX,
            backgroundColor: "white",
            border: "1px solid gray",
            zIndex: 1000,
            padding: "10px 30px",
            borderRadius: "8px",
            boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
          }}
        >
          <div style={{ display: "grid" }}>
            <button
              className="btn btn-secondary"
              onClick={() => {
                setAdditionalChargesModal(true);
                loadAdditionalCharges(contextMenu.data);
                setContextMenu(null);
              }}
            >
              Add Additional Charges
            </button>
          </div>
        </div>
      )}

      <Modal show={additionalChargesModal} centered dialogClassName="additional-charges-modal-dialog" onHide={closeAdditionalChargesModal}
        backdrop="static"
        keyboard={false}>
        <style>{`
          .additional-charges-modal-dialog {
            width: 70vw;
            max-width: 70vw;
          }
          .additional-charges-modal-dialog .modal-content {
            height: 40vh;
            overflow: hidden;
          }
          .additional-charges-modal-dialog .modal-body {
            overflow-y: auto;
            overflow-x: hidden;
          }
        `}</style>
        <Modal.Header closeButton>
          <Modal.Title>Add Additional Charges</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {chargesLoading ? (
            <div>Loading...</div>
          ) : (
            <div className="table-container" style={{ overflowX: "auto", width: "100%", maxWidth: "100%" }}>
              <table>
                <thead className="dynoTable">
                  <tr>
                    <th>Select</th>
                    <th>Description</th>
                    <th>Rate</th>
                    <th>Qty</th>
                    <th>Amount</th>
                    <th>Tax Code</th>
                    <th>Vat</th>
                    <th>Total</th>
                    <th>Posting</th>
                    <th>Remarks</th>
                    <th>From Rent</th>
                  </tr>
                </thead>
                <tbody>
                  {additionalCharges?.map((row, index) => (
                    <tr key={row.RecordId ?? index} style={row.isRenewalLocked ? { backgroundColor: "#e9ecef", opacity: 0.65 } : undefined}>
                      <td className="m-0 p-0 text-center">
                        <div className="center mt-1">
                          <input
                            type="checkbox" className="center"
                            checked={row.isSelected || false}
                            disabled={row.isRenewalLocked || false}
                            onChange={(e) => handleCheckboxChange(index, "isSelected", e.target.checked)}
                            style={{ width: "20px", height: "20px" }}
                          />
                        </div>
                      </td>
                      <td className="m-0 p-0">
                        <input
                          className="p-1"
                          value={row.Description}
                          disabled
                          style={{ width: "300px" }}
                        />
                      </td>
                      <td className="m-0 p-0">
                        <input
                          className="p-1"
                          type="number" onKeyDown={preventNegativeSign}
                          value={row.Rate || ""}
                          disabled={row.isRenewalLocked || false}
                          onChange={(e) => handleCheckboxChange(index, "Rate", e.target.value)}
                          style={{ width: "100px" }}
                        />
                      </td>
                      <td className="m-0 p-0">
                        <input
                          className="p-1" onKeyDown={preventNegativeSign}
                          type="number"
                          value={row.Qty || ""}
                          disabled={row.isRenewalLocked || false}
                          onChange={(e) => handleCheckboxChange(index, "Qty", e.target.value)}
                          style={{ width: "100px" }}
                        />
                      </td>
                      <td className="m-0 p-0">
                        <input
                          className="p-1"
                          type="text"
                          value={row.Amount?.toFixed(currencyPrecision?.decimalNumbers) || ""}
                          disabled
                          style={{ width: "120px" }}
                        />
                      </td>
                      <td className="m-0 p-0">
                        <select
                          className="p-1"
                          value={resolveTaxCodeValue(row)}
                          onChange={(e) => handleVatChange(index, e.target.value)}
                          style={{ width: "250px" }}
                        >
                          <option value="">Select Tax Code</option>
                          {taxCodeList.map((tax) => (
                            <option key={tax.value} value={tax.value}>
                              {tax.text}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td className="m-0 p-0">
                        <input
                          className="p-1"
                          value={row.VAT?.toFixed(currencyPrecision?.decimalNumbers) || 0}
                          disabled
                          style={{ width: "100px" }}
                        />
                      </td>
                      <td className="m-0 p-0">
                        <input
                          className="p-1"
                          value={row.Total?.toFixed(currencyPrecision?.decimalNumbers) || "0.00"}
                          disabled
                          style={{ width: "120px" }}
                        />
                      </td>
                      <td className="m-0 p-0 text-center">
                        <input
                          type="checkbox"
                          checked={row.Posting || false}
                          onChange={(e) => handleCheckboxChange(index, "Posting", e.target.checked)}
                          style={{ width: "20px", height: "20px" }}
                        />
                      </td>
                      <td className="m-0 p-0">
                        <input
                          className="p-1"
                          value={row.Remarks || ""}
                          onChange={(e) => handleCheckboxChange(index, "Remarks", e.target.value)}
                          style={{ width: "300px" }}
                        />
                      </td>
                      <td className="m-0 p-0 text-center">
                        <input
                          type="checkbox" className="w-100"
                          checked={row.IsDeposit || false}
                          onChange={(e) => handleCheckboxChange(index, "IsDeposit", e.target.checked)}
                          style={{ width: "20px", height: "20px" }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className='end p-3'>
          <button className="mainbtn" disabled={chargesLoading || chargesSaving} onClick={handleSaveAdditionalCharges}>
            {chargesSaving ? <ClipLoader color="#ffffff" size={16} /> : "Save"}
          </button>
          <button className="mainbtnRed" onClick={closeAdditionalChargesModal}>Close</button>
        </Modal.Footer>
      </Modal>

      <Modal show={renewBulkModal} centered onHide={closeRenewBulkModal} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Renew Selected Leases</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">{selectedRows.length} lease(s) selected for renewal.</div>
          <div className="mb-3">
            <label className="mb-1 d-block">Transaction Date</label>
            <DatePicker
              selected={renewBulkDate}
              onChange={(date) => setRenewBulkDate(date)}
              dateFormat="dd-MMM-yyyy"
              className="p-2 form-control w-100"
            />
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="skipOnOverlap"
              checked={renewSkipOnOverlap}
              onChange={(e) => setRenewSkipOnOverlap(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="skipOnOverlap">
              Skip leases with overlapping periods
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer className='end p-3'>
          <button className="mainbtn" disabled={renewBulkSaving} onClick={handleRenewBulk}>
            {renewBulkSaving ? <ClipLoader color="#ffffff" size={16} /> : "Renew"}
          </button>
          <button className="mainbtnRed" onClick={closeRenewBulkModal}>Close</button>
        </Modal.Footer>
      </Modal>

      <Modal show={terminationBulkModal} centered onHide={closeTerminationBulkModal} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Terminate Selected Leases</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">{selectedRows.length} lease(s) selected for termination.</div>
          <div className="row">
            <div className="col-6 mb-3">
              <label className="mb-1 d-block">Transaction Date</label>
              <DatePicker
                selected={terminationTranDate}
                onChange={(date) => setTerminationTranDate(date)}
                dateFormat="dd-MMM-yyyy"
                className="p-2 form-control w-100"
              />
            </div>
            <div className="col-6 mb-3">
              <label className="mb-1 d-block">Notice Date</label>
              <DatePicker
                selected={terminationNoticeDate}
                onChange={(date) => setTerminationNoticeDate(date)}
                dateFormat="dd-MMM-yyyy"
                className="p-2 form-control w-100"
              />
            </div>
            <div className="col-6 mb-3">
              <label className="mb-1 d-block">Key Return Date</label>
              <DatePicker
                selected={terminationKeyReturnDate}
                onChange={(date) => setTerminationKeyReturnDate(date)}
                dateFormat="dd-MMM-yyyy"
                className="p-2 form-control w-100"
              />
            </div>
            <div className="col-6 mb-3">
              <label className="mb-1 d-block">Date Paid on Vacating</label>
              <DatePicker
                selected={terminationVacatingDate}
                onChange={(date) => setTerminationVacatingDate(date)}
                dateFormat="dd-MMM-yyyy"
                className="p-2 form-control w-100"
              />
            </div>
          </div>
          <div className="mb-3">
            <label className="mb-1 d-block">Reason</label>
            <textarea
              className="p-2 form-control w-100"
              rows={2}
              value={terminationReason}
              onChange={(e) => setTerminationReason(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label className="mb-1 d-block">Remarks</label>
            <textarea
              className="p-2 form-control w-100"
              rows={2}
              value={terminationRemarks}
              onChange={(e) => setTerminationRemarks(e.target.value)}
            />
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="useComputedBalance"
              checked={terminationUseComputedBalance}
              onChange={(e) => setTerminationUseComputedBalance(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="useComputedBalance">
              Use computed balance
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer className='end p-3'>
          <button className="mainbtnRed" disabled={terminationBulkSaving} onClick={handleTerminateBulk}>
            {terminationBulkSaving ? <ClipLoader color="#ffffff" size={16} /> : "Terminate"}
          </button>
          <button className="mainbtnRed" onClick={closeTerminationBulkModal}>Close</button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default RenewListing;
